<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">闸机设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="DeviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="是否开放">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in EqStatusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-loading="searching"
              element-loading-text="加载中..."
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
            <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="DeviceNo" label="设备编号">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).DeviceNo
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column prop="Ip" label="IP地址"
                ><template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).Ip
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="CustomType" label="闸机类型"
                ><template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).CustomType
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="WarrantyPeriod" label="保修期">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.JsonExtend == null
                        ? ""
                        : JSON.parse(scope.row.JsonExtend).WarrantyPeriod
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="ConditionNum" label="通过人数">
              </el-table-column>
              <el-table-column prop="IsOnline" label="是否开放">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color:red;"
                    >离线</span
                  >
                  <span v-if="scope.row.IsOnline == true" style="color:green;"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                      @click="editClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "GateEquipmentView",
  controller: "UI",
  action: "GateEquipmentView",
  data() {
    return {
      searching: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionData: [],
      EquipmentType: "", //设备类型
      DeviceId: "",
      DeviceName: "", //设备名称
      RegionId: "", //地区ID
      EqStatusArr: [
        { value: true, label: "开放" },
        { value: false, label: "关闭" },
      ],
      IsOnline: "", //在线是否
      DeviceType: "",
    };
  },
  created: function() {
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "闸机设备管理查看";
    this.logInfo.LogMessage ="闸机设备管理查看";
    this.logInfo.ModuleName = "设备管理";
    this.logInfo.PageName = "闸机设备列表页";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      this.searching = true;
      let searchInfo = {
        DeviceName: this.DeviceName, //设备名称
        IsOnline: this.IsOnline, //在线是否
        EquipmentType: "Gate",
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.DeviceName = "";
      this.IsOnline = "";
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/equipment/UI/GateEquipmentInfo",
        query: {
          InfoId: row.DeviceId,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/equipment/UI/GateEquipmentInfo",
        // name: 'mallList',
        query: {
          InfoId: row.DeviceId,
          type: "query",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/equipment/UI/GateEquipmentInfo",
        query: {
          type: "add",
        },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.logInfo.ActionName = "闸机设备信息删除";
              this.logInfo.LogMessage = r
                ? "闸机设备信息删除成功"
                : "闸机设备信息删除失败";
              this.logInfo.ModuleName = "设备管理";
              this.logInfo.PageName = "闸机设备列表页";
              this.addOperationLog();
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  },
};
</script>
